"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var FlatfileUploader_1 = __importDefault(require("../FlatfileUploader"));
var UnsupportedOptionTemplate = function (_a) {
    var provider = _a.provider, handleGoBack = _a.handleGoBack, formValues = _a.formValues, transactionsData = _a.transactionsData, setTransactionsData = _a.setTransactionsData;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 1 }, { children: [(0, end2end_1.getProviderAsNice)(provider), " Integration coming soon"] })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, pt: 2, pb: 4 }, { children: ["We are working to add more integrations. We'll contact you as soon as the", ' ', (0, end2end_1.getProviderAsNice)(provider), " integration is ready."] })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, mt: 2 }, { children: ["You can still use Hudled by uploading your transactions from the", ' ', "previous 13 months as a CSV."] })), (0, jsx_runtime_1.jsx)(FlatfileUploader_1.default, { formValues: formValues, transactionsData: transactionsData, setTransactionsData: setTransactionsData }), (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ onClick: handleGoBack, sx: { mt: 2, ml: -2 } }, { children: "Go back" }))] }));
};
exports.default = UnsupportedOptionTemplate;
